module.exports = __webpack_public_path__ + "img/box-arrow-in-right.1240f698.svg";